import { Component } from "@angular/core";

import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-loading",
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: "./loading.component.html",
  styleUrl: "./loading.component.scss",
})
export class LoadingComponent {}
